fTA<template>
  <div class="atividades-pontoletronicos ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->
        <b-col cols="2">
          <label for="select-empresa">Empresa</label>
          <multiselect
            id="selecao-empresa-sol"
            v-model="valor_empresa"
            required
            :options="empresas"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            @close="loadFiliais()"
            :preserve-search="true"
            placeholder="Selecione a empresa"
            label="empresa"
            track-by="empresa"
            name="empresa"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Empresa selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="2">
          <label for="select-garagem_sol">Filial</label>
          <multiselect
            id="selecao-filial-sol"
            v-model="valor_filial"
            required
            :options="filiais"
            :multiple="true"
            :taggable="true"
            @close="loadLote()"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecione a filial"
            label="filial"
            track-by="filial"
            name="filial"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Filial selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <!-- Lote-->
        <b-col cols="2">
          <label for="select-lote">Lote</label>
          <multiselect
            id="selecao-lote"
            v-model="valor_lote"
            required
            :options="lotes"
            :multiple="true"
            :taggable="true"
            @close="loadLinhas()"
            @tag="addTag"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Lote"
            label="lote"
            track-by="lote"
            name="lote"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Lote selecionado</span
              ></template
            >
          </multiselect>
        </b-col>

        <!-- Linha-->
        <b-col cols="1">
          <label for="select-status">Linha</label>
          <multiselect
            id="selecao-status-sol"
            v-model="valor_linha"
            required
            :options="linhas"
            :multiple="true"
            :taggable="true"
            @close="loadStatus()"
            @tag="addTag"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Linha(s)"
            label="linha"
            track-by="linha"
            name="linha"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Linha(s) selecionada(s)</span
              ></template
            >
          </multiselect>
        </b-col>

        <!-- Status-->
        <b-col cols="2">
          <label for="select-status">Status</label>
          <multiselect
            id="selecao-status-sol"
            v-model="valor_status"
            required
            :options="statuss"
            :multiple="true"
            :taggable="true"
            @tag="addTag"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Status"
            label="status"
            track-by="status"
            name="status"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} status selecionado</span
              ></template
            >
          </multiselect>
        </b-col>

        <LoadingModal v-if="isLoading" />

        <!-- Data serviço -->
        <b-col cols="2">
          <div>
            <label for="datepicker-placeholder">Data do serviço</label>
            <b-form-datepicker
              id="datepicker-placeholder"
              v-model="valor_dtservico"
              required
              placeholder="Data do serviço"
              locale="pt-BR"
              date-format-options="DD/MM/YYYY"
            ></b-form-datepicker>
          </div>
        </b-col>

        <b-col cols="1" class="mt-4">
          <b-button
            size="sm"
            id="btn-pesquisar"
            variant="primary"
            block
            class="mr-2 mt-2"
            @click="
              (carregando = true),
                loadPontoMonitoramento(),
                getBackgroundColor()
            "
          >
            Pesquisar
          </b-button>
        </b-col>

        <b-col cols="10">
          <b-row class="mt-3 ml-3">
            <!--                   -->
            <b-col cols="3">
              <b-card
                class="mr-2"
                border-variant="success"
                header="QUANTIDADE DE ATIVIDADES"
                header-bg-variant="gray"
                header-text-variant="black"
                align="center"
              >
                <b-card-text>
                  <h2>
                    {{ itemsFiltered.length > 0 ? itemsFiltered.length : 0 }}
                  </h2>
                </b-card-text>
              </b-card>
            </b-col>

            <b-col cols="3">
              <b-card
                class="mr-2"
                border-variant="warning"
                header="QUANTIDADE AGUARDANDO"
                header-bg-variant="danger"
                header-text-variant="white"
                align="center"
              >
                <b-card-text>
                  <h2>
                    {{
                      itemsFiltered.filter((item) => item.status === "PENDENTE")
                        .length
                    }}
                  </h2>
                </b-card-text>
              </b-card>
            </b-col>

            <b-col cols="3">
              <b-card
                class="mr-2"
                border-variant="primary"
                header="QUANTIDADE REALIZADO"
                header-bg-variant="success"
                header-text-variant="white"
                align="center"
              >
                <b-card-text>
                  <h2>
                    {{
                      itemsFiltered.filter(
                        (item) => item.status === "REALIZADO"
                      ).length
                    }}
                  </h2>
                </b-card-text>
              </b-card>
            </b-col>

            <b-col cols="3">
              <b-card
                class="mr-2"
                border-variant="primary"
                header="MUDOU DE LINHA"
                header-bg-variant="yellow"
                header-text-variant="black"
                align="center"
              >
                <b-card-text>
                  <h2>
                    {{
                      itemsFiltered.filter(
                        (item) => item.status === "MUIDOU DE LINHA"
                      ).length
                    }}
                  </h2>
                </b-card-text>
              </b-card>
            </b-col>
          </b-row>
        </b-col>

        <!--
              <b-col cols="2" class="mt-3" >
                <label for="input-live">Qtd de tabelas alteradas</label> 
                <b-input-group-text readonly >  {{ pontoletronicosalteracoes.map(tab => tab.tabelas).join('') }}  </b-input-group-text>             
              </b-col> 
            -->

        <b-col cols="2">
          <b-col class="mb-0 mt-5">
            <label for="input-busca">Pesquisa no grid </label>
            <b-form-input
              id="buscamonitoramento"
              v-model="search"
              required="required"
              placeholder="Motorista / Cobrador / Carro / Linha / Tabela"
            ></b-form-input>
          </b-col>
        </b-col>
      </b-row>
    </b-form>

    <b-col>
      <div>
        <b-progress class="mt-3 mp-3" :max="barra_limite">
          <b-progress-bar
            variant="success"
            :value="barra_inicial"
            :label="`${((barra_inicial / barra_limite) * 100).toFixed(2)} %`"
          ></b-progress-bar>
        </b-progress>
      </div>
    </b-col>

    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>

    <b-table
      id="escaladiariamonitoramento"
      small
      hover
      striped
      sticky-header="940px"
      :items="itemsFiltered"
      :fields="fieldsescaladiaria"
    >
      <!-- Customização da célula com a foto -->
      <template v-slot:cell(foto1)="data">
        <div class="img-cell-content">
          <img
            :src="data.item.foto_url_thumbnail"
            alt=""
            style="max-width: 90px; max-height: 78px"
          />
          <p>
            {{
              data.item.ope_real && data.item.foto_url_thumbnail
                ? data.item.ope_real
                : "-"
            }}
          </p>
          <!-- <p>{{ data.item.id_motorista_real == data.item.id_funcionario_foto && data.item.foto_url_thumbnail ? data.item.motorista_real : data.item.id_cobrador_real == data.item.id_funcionario_foto && data.item.foto_url_thumbnail ? data.item.cobrador_real : '-' }}</p> -->
        </div>
      </template>

      <template v-slot:cell(status)="data">
        <div
          :class="[
            'cell-content',
            getBackgroundColor(data.item),
            'larger-font',
          ]"
        >
          {{ data.value }}
        </div>
      </template>

      <template v-slot:cell(actions)="data">
        <div class="cell-content">
          <b-button
            @click="editTabela(data.item)"
            title="Alterar tabela"
            size="sm"
            variant="primary"
            class="mr-2 mt-2"
            v-b-modal.modal-multi-1
          >
            <i class="fa fa-exclamation-circle"></i>
          </b-button>
        </div>
      </template>
    </b-table>

    <!--tbl de dados 
    <b-table id="escaladiariamonitoramento"  small hover striped sticky-header="935px"  :items="itemsFiltered" :fields="fieldsescaladiaria" >    

            
  <template v-slot:cell(foto1)="data">
  <div>
    <img :src="data.item.foto_url_thumbnail" alt="" style="max-width: 100px; max-height: 100px;">
    <p>{{  data.item.id_motorista_real == data.item.id_funcionario_foto && data.item.foto_url_thumbnail  ?   data.item.motorista_real :  data.item.id_cobrador_real == data.item.id_funcionario_foto && data.item.foto_url_thumbnail ? data.item.cobrador_real: '-' }}</p>   
    
  </div>
</template>

        <template v-slot:cell(status)="data">
          <div :class="getBackgroundColor(data.item)">
            {{ data.value }}
          </div>
        </template>
          



        <template slot="cell(actions)" slot-scope="data"  >
          <b-button  @click="editTabela(data.item)"    title="Alterar tabela"  size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.modal-multi-1>                
            <i class="fa fa-exclamation-circle"></i>              
          </b-button> 
        </template>   
    </b-table>
    -->

    <!--  MODAL MANUTENÇÃO DA TABELA  -->
    <!--  MODAL MANUTENÇÃO DA TABELA  -->
    <!--  MODAL MANUTENÇÃO DA TABELA  -->
    <div>
      <b-modal
        id="modal-multi-1"
        size="xl"
        title="Manutenção de tabela.:"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
      >
        <!-- -->
        <div>
          <b-row>
            <input
              id="id-sac"
              type="hidden"
              v-model="escalaservico.id_tabela"
            />

            <b-col cols="2" class="mt-5">
              <label for="input-live">Linha</label>
              <b-form-input
                id="es-linha"
                v-model="escalaservico.linha"
                readonly
                placeholder=""
                class="mb-3 alttabela"
              ></b-form-input>
            </b-col>

            <b-col cols="3" class="mt-5">
              <label for="input-live">Tabela</label>
              <b-form-input
                id="es-tabela"
                v-model="escalaservico.tabela"
                readonly
                placeholder=""
                class="mb-3 alttabela"
              ></b-form-input>
            </b-col>

            <b-col cols="3" class="mt-5">
              <label for="input-live">Inicio Serviço</label>
              <b-form-input
                id="es-jini"
                v-model="escalaservico.servico_ini"
                readonly
                placeholder=""
                class="mb-3 alttabela"
              ></b-form-input>
            </b-col>

            <b-col cols="3" class="mt-5">
              <label for="input-live">Término Serviço</label>
              <b-form-input
                id="es-jter"
                v-model="escalaservico.servico_ter"
                readonly
                placeholder=""
                class="mb-3 alttabela"
              ></b-form-input>
            </b-col>
          </b-row>

          <!-- Carro a ser alterado-->
          <b-row>
            <b-col cols="2" class="mt-5">
              <label for="input-live">Carro Atual</label>
              <b-form-input
                id="es-carroa"
                v-model="escalaservico.carroprogramado"
                readonly
                placeholder=""
                class="mb-3 alttabela"
              ></b-form-input>
            </b-col>

            <b-col cols="2" class="mt-5">
              <label for="input-live">Carro Novo</label>
              <b-form-input
                id="es-carron"
                v-model="valor_carro"
                @keyup.enter="loadVeiculo()"
                placeholder=""
                class="mb-3 alttabela"
              ></b-form-input>
            </b-col>

            <b-col cols="2" class="mt-5">
              <label for="input-live">Placa </label>
              <b-input-group-text>
                {{ carro.map((car) => car.placa).join(", ") }}
              </b-input-group-text>
            </b-col>

            <b-col cols="6" class="mt-5">
              <label for="es-motc">Motivo da alteração do carro</label>
              <div>
                <b-form-select
                  id="es-selec-motc"
                  v-model="escalaservico.id_motivo_carro"
                  :options="motivosalteracoes"
                  class="mb-3"
                  text-field="motivo"
                >
                </b-form-select>
              </div>
            </b-col>
          </b-row>

          <!-- Motorista a ser alterado-->
          <b-row>
            <b-col cols="2" class="mt-5">
              <label for="input-live">Motorista Atual</label>
              <b-form-input
                id="es-mota"
                v-model="escalaservico.motprogramado"
                readonly
                placeholder=""
                class="mb-3 alttabela"
              ></b-form-input>
            </b-col>

            <b-col cols="2" class="mt-5">
              <label for="input-live">Motorista Novo</label>
              <b-form-input
                id="es-motn"
                v-model="valor_motorista"
                @keyup.enter="loadBuscaMotorista()"
                placeholder=""
                class="mb-3 alttabela"
              ></b-form-input>
            </b-col>

            <b-col cols="2" class="mt-5">
              <label for="input-live">Motorista função</label>
              <b-input-group-text>{{
                motorista.map((mt) => mt.funcao).join(", ")
              }}</b-input-group-text>
            </b-col>

            <b-col cols="6" class="mt-5">
              <label for="input-parecer">Motivo da alteração motorista</label>
              {{ escalaservico.id_motivo_motorista }}
              <div>
                <b-form-select
                  id="es-selec-motm"
                  v-model="escalaservico.id_motivo_motorista"
                  :options="motivosalteracoes"
                  class="mb-3"
                  text-field="motivo"
                >
                </b-form-select>
              </div>
            </b-col>
          </b-row>

          <!-- Cobrador a ser alterado-->
          <b-row>
            <b-col cols="2" class="mt-5">
              <label for="input-live">Cobrador Atual</label>
              <b-form-input
                id="es-coba"
                v-model="escalaservico.cobprogramado"
                readonly
                placeholder=""
                class="mb-3 alttabela"
              ></b-form-input>
            </b-col>

            <b-col cols="2" class="mt-5">
              <label for="input-live">Cobrador Novo</label>
              <b-form-input
                id="es-cobn"
                v-model="valor_cobrador"
                @keyup.enter="loadBuscaCobrador()"
                placeholder=""
                class="mb-3 alttabela"
              ></b-form-input>
            </b-col>

            <b-col cols="2" class="mt-5">
              <label for="input-live">Cobrador função</label>
              <b-input-group-text>{{
                cobrador.map((cb) => cb.funcao).join(", ")
              }}</b-input-group-text>
            </b-col>

            <b-col cols="6" class="mt-5">
              <label for="input-parecer">Motivo da alteração cobrador</label>
              <div>
                <b-form-select
                  id="es-selec-motc"
                  v-model="escalaservico.id_motivo_cobrador"
                  :options="motivosalteracoes"
                  class="mb-3"
                  text-field="motivo"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-button
              class="mt-3"
              variant="success"
              block
              @click="
                putTabelaDiaria(),
                  putTabelaDiariaPartidas(),
                  postTabelaDiarialog(),
                  resetEditTabela()
              "
              >Gravar</b-button
            >
          </b-row>
        </div>
      </b-modal>
    </div>
    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment, { now } from "moment";
import { mapState } from "vuex";
import * as XLSX from "xlsx";
import LoadingModal from "../utilitarios/LoadingModal";

export default {
  name: "escalaservico",

  computed: {
    ...mapState(["user"]),

    itemsFiltered() {
      let valores = [];
      valores = this.pontoletronicos.filter((item) => {
        //const motprogramado = item.motorista_prog || ''; // devido alguns valores retornarem null se faz necessario a substituição para não dar erro no filtro
        const programado = item.registro_prog || "";
        const tabela = item.tabela || "";
        const realizado = item.registro_real || "";
        const veiculo = item.prefixo || "";

        return (
          /*
            item.linha.toLowerCase().includes(this.search.toLowerCase()) ||            
            item.tabela.toLowerCase().includes(this.search.toLowerCase()) ||            
            item.servico_ini.toLowerCase().includes(this.search.toLowerCase()) ||            
            */
          //motprogramado.indexOf(this.search) >-1 ||
          programado.indexOf(this.search) > -1 ||
          tabela.indexOf(this.search) > -1 ||
          realizado.indexOf(this.search) > -1 ||
          veiculo.indexOf(this.search) > -1
        );
      });
      return valores;
    },
  },

  data: function () {
    return {
      isLoading: false,
      empresa: {},
      empresas: [], // [] lista
      filial: {},
      filiais: [], // [] lista
      lotes: [],
      escalaservico: {},
      pontoletronicos: [],
      linhas: [],
      valor_empresa: "",
      valor_filial: "",
      valor_lote: "",
      valor_linha: "",
      valor_status: "",
      valor_dtservico: "",
      escalaservico: {}, // [] lista
      search: "",
      motivosalteracoes: [],
      valor_carro: "",
      valor_motorista: "",
      valor_cobrador: "",
      carro: [],
      motorista: [],
      cobrador: [],
      mode: "save",
      carregando: false,
      atualizando: false,
      status: {},
      statuss: [], // [] lista
      barra_inicial: 0,
      barra_limite: 60000 * 3, // temporizador 60.000 milisegundos refere-se a 1 minutos
      fieldsescaladiaria: [
        {
          key: "nsr",
          label: "NSR",
          sortable: true,
          tdClass: "centered-text larger-font",
        },
        {
          key: "foto1",
          label: "Batida",
          sortable: false,
          tdClass: "img-cell-content",
        },
        {
          key: "linha",
          label: "Linha",
          sortable: true,
          tdClass: "centered-text larger-font",
        },
        {
          key: "tabela",
          label: "Tabela",
          sortable: true,
          tdClass: "centered-text larger-font",
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          tdClass: "centered-text larger-font",
        },
        {
          key: "legenda",
          label: "Atividade",
          sortable: true,
          tdClass: "centered-text larger-font",
        },
        {
          key: "chegada_prog",
          label: "Hora programada",
          sortable: true,
          formatter: (value, key, escalaservico) => {
            return moment(escalaservico.chegada_prog)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
          tdClass: "centered-text larger-font",
        },
        {
          key: "dt_marcacao",
          label: "Hora realizada",
          sortable: true,
          formatter: (value, key, escalaservico) => {
            return moment(escalaservico.dt_marcacao)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
          tdClass: "centered-text larger-font",
        },
        {
          key: "registro_prog",
          label: "Operador programado",
          sortable: true,
          tdClass: "centered-text larger-font",
        },
        {
          key: "registro_real",
          label: "Operador realizado",
          sortable: true,
          tdClass: "centered-text larger-font",
        },
        /*
    { key: 'cobrador_prog', label: 'Cob_Prog', sortable: true, tdClass: 'centered-text larger-font' },  
    { key: 'cobrador_real', label: 'Cob_Real', sortable: true, tdClass: 'centered-text larger-font' },  
     */
        //{ key: 'carro_programado', label: 'Carro_Prog', sortable: true, tdClass: 'centered-text larger-font' },
        {
          key: "prefixo",
          label: "Carro",
          sortable: true,
          tdClass: "centered-text larger-font",
          formatter: this.formatCarro,
        },
        // { key: 'actions', label: 'Ações' },
      ],
    };
  },

  components: {
    Multiselect,
    LoadingModal,
  },
  methods: {
    formatCarro(value) {
      return value ? value : "-";
    },

    getBackgroundColor(item) {
      if (item.status) {
        //return item.motprogramado === item.motrealizado ? '' : 'bg-yellow';
        return item.status === "REALIZADO"
          ? "bg-green"
          : item.status === "PENDENTE"
          ? "bg-red"
          : "bg-yellow";
      }
    },

    temporizador() {
      this.handle = setInterval(() => {
        this.barra_inicial = this.barra_inicial + 1000;
        if (this.barra_inicial >= this.barra_limite) {
          this.barra_inicial = 0;
          this.loadPontoMonitoramento(), this.getBackgroundColor();
        }
      }, 1000);
    },

    loadEmpresas() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios.get(url, { params }).then((res) => {
        this.empresas = res.data.map((empresa) => {
          return {
            id_empresa: empresa.id_empresa,
            empresa: empresa.nomeempresarial,
          };
        });
      });
    },

    loadFiliais() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa: this.user.id_empresa, // Verifica se há empresas e junta os ids como string
        psg: this.user.psg, // 12/04/2024 AS 12:16h enquanto não migrar 100% para a base da via Sudeste
      };
      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios.get(url, { params }).then((res) => {
        this.filiais = res.data.map((filial) => {
          return { id_filial_erp: filial.id_filial_erp, filial: filial.filial };
        });
      });
    },

    loadLote() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/planejamento/escala/lote`;
      axios
        .get(url, { params })
        .then((res) => {
          this.lotes = res.data.map((lot) => {
            return { id_lote: lot.id_lote, lote: lot.lote };
          });
        })
        .catch(showError);
    },

    loadLinhas() {
      let params = {
        psg: this.user.psg,
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.valor_filial.map((l) => l.id_filial_erp)}`,
        id_lote: `${this.valor_lote.map((l) => l.id_lote)}`,
      };
      const url = `${baseApiUrl}/planejamento/linha/cad`;
      axios
        .get(url, { params })
        .then((res) => {
          this.linhas = res.data.map((lin) => {
            return { ...lin, value: lin.id_linha, linha: lin.linha }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadStatus() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/planejamento/escala/status`;
      axios.get(url, { params }).then((res) => {
        this.statuss = res.data.map((sta) => {
          return { ...sta, value: sta.id, status: sta.status };
        });
      });
    },

    loadMotivoAlteracaoTabela() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/planejamento/escala/alteracao/motivo`;
      axios.get(url, { params }).then((res) => {
        this.motivosalteracoes = res.data.map((mot) => {
          return { ...mot, value: mot.id, motivo: mot.motivo };
        });
      });
    },

    loadPontoMonitoramento() {
      this.isLoading = true; // Ative o indicador de carregamento
      let params = {
        psg: this.user.psg,
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.valor_filial.map((l) => l.id_filial_erp)}`,
        id_lote: `${this.valor_lote.map((l) => l.id_lote)}`,
        id_linha: `${this.valor_linha.map((l) => l.id_linha)}`,
        id_status: `${this.valor_status.map((l) => l.id)}`,
        dt_servico: `${this.valor_dtservico}`,
      };

      const url = `${baseApiUrl}/pontoeletronico/monitoramento`;
      axios.get(url, { params }).then((res) => {
        this.carregando = false;
        this.loadPontoMonitoramentoAlteracoes();
        this.pontoletronicos = res.data.map((ed) => {
          return { ...ed };
        });
        this.isLoading = false; // Desative o indicador de carregamento
      });
    },

    // contador alteracoes escala diaria
    loadPontoMonitoramentoAlteracoes() {
      let params = {
        psg: this.user.psg,
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.valor_filial.map((l) => l.id_filial_erp)}`,
        dt_servico: `${this.valor_dtservico}`,
      };

      const url = `${baseApiUrl}/planejamento/escala/diariaalteracoes`;
      axios.get(url, { params }).then((res) => {
        this.pontoletronicosalteracoes = res.data;
        //this.carregando = false;
        //this.pontoletronicosalteracoes = res.data.map(ed => {               return { ... ed}             })
      });
    },

    editTabela(escalaservico) {
      this.escalaservico = { ...escalaservico };
    },
    resetEditTabela() {
      this.valor_carro = "";
      this.valor_cobrador = "";
      this.valor_motorista = "";
      this.escalaservico = [];
      this.pontoletronicosalteracoes = [];
      this.carro = [];
      this.cobrador = [];
      this.motorista = [];
    },

    putTabelaDiaria() {
      let corpo = {
        psg: this.user.psg,
        id: `${this.escalaservico.id_escaladiaria}`,
        id_tabela: `${this.escalaservico.id_tabela}`,
        id_carro_real: `${this.carro}`
          ? `${this.carro.map((car) => car.id_veiculo).join(", ")}`
          : null,
        id_motorista_real:
          `${this.motorista.map((mt) => mt.id_funcionario)}` == ""
            ? null
            : `${this.motorista.map((mt) => mt.id_funcionario)}`,
        id_cobrador_real:
          `${this.cobrador.map((cb) => cb.id_funcionario)}` == ""
            ? null
            : `${this.cobrador.map((cb) => cb.id_funcionario)}`,
        id_funcionario_monitoramento: `${this.user.id_funcionario}`,
      };
      const url = `${baseApiUrl}/planejamento/escala/alteracao`;
      axios
        .post(url, corpo)
        .then(() => {
          //this.putTabelaDiariaPartidas()
          //       this.$toasted.global.defaultSuccess()
        })
        .catch(showError);
    },

    putTabelaDiariaPartidas() {
      let corpo = {
        psg: this.user.psg,
        id_servico: `${this.escalaservico.id_escaladiaria}`,
        dt_servico: `${this.escalaservico.dt_servico}`,
        id_tabela: `${this.escalaservico.id_tabela}`,
        id_carro_real: `${this.carro}`
          ? `${this.carro.map((car) => car.id_veiculo).join(", ")}`
          : null,
        id_motorista_real:
          `${this.motorista.map((mt) => mt.id_funcionario)}` == ""
            ? null
            : `${this.motorista.map((mt) => mt.id_funcionario)}`,
        id_cobrador_real:
          `${this.cobrador.map((cb) => cb.id_funcionario)}` == ""
            ? null
            : `${this.cobrador.map((cb) => cb.id_funcionario)}`,
        id_funcionario_alteracao: `${this.user.id_funcionario}`,
        id_status: 1,
      };
      const url = `${baseApiUrl}/planejamento/escala/alteracao/partidas`;
      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.loadPontoMonitoramento();
        })
        .catch(showError);
    },

    postTabelaDiarialog() {
      let corpo = {
        psg: this.user.psg,
        id_empresa_grupo: `${this.user.id_grupo_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.valor_filial.map((l) => l.id_filial_erp)}`,
        id_servico: `${this.escalaservico.id_escaladiaria}`,
        id_linha: `${this.escalaservico.id_linha}`,
        id_tabela: `${this.escalaservico.id_tabela}`,
        dt_servico: `${this.escalaservico.dt_servico}`,
        id_carro_prog:
          `${this.escalaservico.id_carro_prog}` == null
            ? ""
            : `${this.escalaservico.id_carro_prog}`,
        id_carro_real:
          `${this.carro.map((cr) => cr.id_veiculo)}` == ""
            ? null
            : `${this.carro.map((cr) => cr.id_veiculo)}`,
        id_carro_mot: `${this.escalaservico.id_motivo_carro}`,
        id_mot_prog:
          `${this.escalaservico.id_motorista_prog}` == null
            ? ""
            : `${this.escalaservico.id_motorista_prog}`,
        id_mot_real:
          `${this.motorista.map((mt) => mt.id_funcionario)}` == "" ||
          `${this.motorista.map((mt) => mt.id_funcionario)}` == null
            ? null
            : `${this.motorista.map((mt) => mt.id_funcionario)}`,
        id_mot_mot: `${this.escalaservico.id_motivo_motorista}`,
        id_cob_prog:
          `${this.escalaservico.id_cobrador_prog}` == null
            ? ""
            : `${this.escalaservico.id_cobrador_prog}`,
        id_cob_real:
          `${this.cobrador.map((cb) => cb.id_funcionario)}` == ""
            ? null
            : `${this.cobrador.map((cb) => cb.id_funcionario)}`,
        id_cob_mot: `${this.escalaservico.id_motivo_cobrador}`,
        id_funcionario_alteracao: `${this.user.id_funcionario}`,
        id_origem: 1, //1 = web gestão operação  | 2 = app fiscalização | 3 = app liberaçaõ de frota
      };
      const url = `${baseApiUrl}/planejamento/escala/alteracao/log`;
      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess();
        })
        .catch(showError);
    },

    loadVeiculo() {
      let params = {
        psg: this.user.psg,
        id_empresa: `${this.user.id_empresa}`,
        prefixo: `${this.valor_carro}`,
      };
      const url = `${baseApiUrl}/manutencao/frota/veiculo`;
      axios
        .get(url, { params })
        .then((res) => {
          this.carro = res.data;
        })
        .catch(showError);
    },

    loadBuscaMotorista() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        registro: `${this.valor_motorista}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/folha/funcionario/busca`;
      axios
        .get(url, { params })
        .then((res) => {
          this.motorista = res.data.map((mt) => {
            return { ...mt };
          });
        })
        .catch(showError);
    },

    loadBuscaCobrador() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        registro: `${this.valor_cobrador}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/folha/funcionario/busca`;
      axios
        .get(url, { params })
        .then((res) => {
          this.cobrador = res.data.map((cb) => {
            return { ...cb };
          });
        })
        .catch(showError);
    },

    limparFiltro() {
      this.search = "";
    },
  },

  mounted() {
    this.loadEmpresas();
    this.loadFiliais();
    this.loadMotivoAlteracaoTabela();
    this.temporizador();
    this.loadPontoMonitoramentoAlteracoes();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.alttabela {
  font-size: 20px;
  text-align: center;
}

/* css para comparar a cor entre as celulas alteradas */
.bg-green {
  background-color: #cfefd1;
}

.bg-yellow {
  background-color: yellow;
}

.bg-red {
  background-color: rgb(230, 136, 136);
}

/*  06/06/2024 aplicando customização */

.larger-font {
  font-size: 15px; /* Ajuste o tamanho conforme necessário */
}
</style>